<template>
    <transition name="fade">
        <button v-if="show"
                id="go-top"
                v-html="icon"
                class="bg-transparent border-0 position-fixed"
                @click="scrollToTop"
        ></button>
    </transition>
</template>

<script>

export default {
    props: {
        icon: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: false
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll (event) {
            if (window.pageYOffset > 100) {
                this.show = true
            } else {
                this.show = false
            }
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        }
    }
}
</script>
